import { SelectionType } from "../../../data";
const firstLevelLimitDesktopView = {
    CurrenctSelectionCount: 5,
    SliceToSelectionCount: 3
};
const LimitMobileView = {
    CurrenctSelectionCount: 5,
    SliceToSelectionCount: 3
};
const secondLevelLimitDesktopView = {
    CurrenctSelectionCount: 6,
    SliceToSelectionCount: 5
};
const MoneyLineMarkets = [SelectionType.ML, SelectionType.MLET, SelectionType.PW, SelectionType.TQ];
export const oddsFormatter = {
    ML: {
        /* Regular ML is when there is winner, draw, loser
        Otherwise there is no draw(tennis) */
        isRegular(market) {
            if (MoneyLineMarkets.indexOf(market.type) < 0) {
                throw "market is not ML";
            }
            return market.selections.length === 3;
        },
        getOddName(selection, useOddTitle) {
            /* istanbul ignore next */
            if (useOddTitle) {
                return selection.title;
            }
            return this.getOddShortName(selection);
        },
        /* ML odd names should be "1", "X", "2" and last symbol of the selection id is used.
            E.g. 0ML25976039_1, 0ML25976039_2, 0ML25976039_3 */
        getOddShortName(selection) {
            let selectionType = selection.id[selection.id.length - 1];
            switch (selectionType) {
                case "1":
                    return selection.isSwapped
                        ? "2"
                        : "1";
                case "2":
                    return "X";
                case "3":
                    return selection.isSwapped
                        ? "1"
                        : "2";
                default:
                    throw Error("selection is not ML");
            }
        }
    },
    Outright: {
        showViewAll(market, mobileView) {
            let minOddsCount = firstLevelLimitDesktopView.CurrenctSelectionCount;
            if (market.selections.length >= minOddsCount) {
                return true;
            }
            return false;
        },
        getOdds(market, mobileView) {
            if (market.type !== SelectionType.QA) {
                throw "market is not Outright";
            }
            let firstLevelLimits = mobileView ?
                LimitMobileView : firstLevelLimitDesktopView;
            let secondLevelLimits = mobileView ?
                LimitMobileView : secondLevelLimitDesktopView;
            if (market.selections.length === firstLevelLimits.CurrenctSelectionCount) {
                return market.selections.slice(0, firstLevelLimits.SliceToSelectionCount);
            }
            else if (market.selections.length >= secondLevelLimits.CurrenctSelectionCount) {
                return market.selections.slice(0, secondLevelLimits.SliceToSelectionCount);
            }
            else {
                return market.selections;
            }
        },
        getOddsOrderClass(selections) {
            if (selections.length === 2 || selections.length === 3) {
                return "outright-single-column-buttons";
            }
            return "";
        }
    }
};
//# sourceMappingURL=OddsFormatHelper.js.map